import DeliveryLeadershipPages from "../Tracks/DeliveryLeadership/App";
import { useSelector,useDispatch } from "react-redux";
import { useEffect } from "react";
import { getloggedInUserRoles } from "../Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";

const DeliveryLeadership = () => {

   const loggedInUser= useSelector((state)=>state.deliveryLeadership.enterpriseID);
   const dispatch= useDispatch();
  
    useEffect(()=>{
      if(loggedInUser){
        dispatch(getloggedInUserRoles({loggedInUser, trackId:1}));  //trackId for dl = 2
      }
    },[loggedInUser,dispatch]);

  return (
    <>
      <DeliveryLeadershipPages />
    </>
  );
};

export default DeliveryLeadership;
